import { render, staticRenderFns } from "./ContractsStore.vue?vue&type=template&id=23f88078&"
import script from "./ContractsStore.vue?vue&type=script&lang=js&"
export * from "./ContractsStore.vue?vue&type=script&lang=js&"
import style0 from "./ContractsStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports